// source: vendormanagement/vendor_evaluation_cycle.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.vendormanagement.CancelVendorEvaluationRequest', null, global);
goog.exportSymbol('proto.vendormanagement.ConcludeVendorEvaluationCycleRequest', null, global);
goog.exportSymbol('proto.vendormanagement.ListVendorEvaluationsRequest', null, global);
goog.exportSymbol('proto.vendormanagement.ListVendorEvaluationsResponse', null, global);
goog.exportSymbol('proto.vendormanagement.RefreshVendorEvaluationStatusRequest', null, global);
goog.exportSymbol('proto.vendormanagement.StartVendorEvaluationRequest', null, global);
goog.exportSymbol('proto.vendormanagement.UpdateVendorEvaluationCycleRequest', null, global);
goog.exportSymbol('proto.vendormanagement.VendorEvaluationConfidence', null, global);
goog.exportSymbol('proto.vendormanagement.VendorEvaluationCycle', null, global);
goog.exportSymbol('proto.vendormanagement.VendorEvaluationCycleStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vendormanagement.VendorEvaluationCycle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vendormanagement.VendorEvaluationCycle.repeatedFields_, null);
};
goog.inherits(proto.vendormanagement.VendorEvaluationCycle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vendormanagement.VendorEvaluationCycle.displayName = 'proto.vendormanagement.VendorEvaluationCycle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vendormanagement.ListVendorEvaluationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vendormanagement.ListVendorEvaluationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vendormanagement.ListVendorEvaluationsRequest.displayName = 'proto.vendormanagement.ListVendorEvaluationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vendormanagement.ListVendorEvaluationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vendormanagement.ListVendorEvaluationsResponse.repeatedFields_, null);
};
goog.inherits(proto.vendormanagement.ListVendorEvaluationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vendormanagement.ListVendorEvaluationsResponse.displayName = 'proto.vendormanagement.ListVendorEvaluationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vendormanagement.StartVendorEvaluationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vendormanagement.StartVendorEvaluationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vendormanagement.StartVendorEvaluationRequest.displayName = 'proto.vendormanagement.StartVendorEvaluationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vendormanagement.CancelVendorEvaluationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vendormanagement.CancelVendorEvaluationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vendormanagement.CancelVendorEvaluationRequest.displayName = 'proto.vendormanagement.CancelVendorEvaluationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vendormanagement.UpdateVendorEvaluationCycleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vendormanagement.UpdateVendorEvaluationCycleRequest.displayName = 'proto.vendormanagement.UpdateVendorEvaluationCycleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vendormanagement.RefreshVendorEvaluationStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vendormanagement.RefreshVendorEvaluationStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vendormanagement.RefreshVendorEvaluationStatusRequest.displayName = 'proto.vendormanagement.RefreshVendorEvaluationStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vendormanagement.ConcludeVendorEvaluationCycleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.displayName = 'proto.vendormanagement.ConcludeVendorEvaluationCycleRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vendormanagement.VendorEvaluationCycle.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.toObject = function(opt_includeInstance) {
  return proto.vendormanagement.VendorEvaluationCycle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendormanagement.VendorEvaluationCycle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.VendorEvaluationCycle.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    vendorId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    chatId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    summary: jspb.Message.getFieldWithDefault(msg, 5, ""),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    overallConfidence: jspb.Message.getFieldWithDefault(msg, 7, 0),
    actionsTakenList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    resultId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    startedBy: jspb.Message.getFieldWithDefault(msg, 10, ""),
    lastActivityAt: (f = msg.getLastActivityAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endedAt: (f = msg.getEndedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendormanagement.VendorEvaluationCycle}
 */
proto.vendormanagement.VendorEvaluationCycle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vendormanagement.VendorEvaluationCycle;
  return proto.vendormanagement.VendorEvaluationCycle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendormanagement.VendorEvaluationCycle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendormanagement.VendorEvaluationCycle}
 */
proto.vendormanagement.VendorEvaluationCycle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 6:
      var value = /** @type {!proto.vendormanagement.VendorEvaluationCycleStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {!proto.vendormanagement.VendorEvaluationConfidence} */ (reader.readEnum());
      msg.setOverallConfidence(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addActionsTaken(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setResultId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartedBy(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastActivityAt(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vendormanagement.VendorEvaluationCycle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendormanagement.VendorEvaluationCycle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.VendorEvaluationCycle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVendorId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getOverallConfidence();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getActionsTakenList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getResultId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getStartedBy();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLastActivityAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string vendor_id = 3;
 * @return {string}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getVendorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.setVendorId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string chat_id = 4;
 * @return {string}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string summary = 5;
 * @return {string}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional VendorEvaluationCycleStatus status = 6;
 * @return {!proto.vendormanagement.VendorEvaluationCycleStatus}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getStatus = function() {
  return /** @type {!proto.vendormanagement.VendorEvaluationCycleStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.vendormanagement.VendorEvaluationCycleStatus} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional VendorEvaluationConfidence overall_confidence = 7;
 * @return {!proto.vendormanagement.VendorEvaluationConfidence}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getOverallConfidence = function() {
  return /** @type {!proto.vendormanagement.VendorEvaluationConfidence} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.vendormanagement.VendorEvaluationConfidence} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.setOverallConfidence = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * repeated string actions_taken = 8;
 * @return {!Array<string>}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getActionsTakenList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.setActionsTakenList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.addActionsTaken = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.clearActionsTakenList = function() {
  return this.setActionsTakenList([]);
};


/**
 * optional string result_id = 9;
 * @return {string}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getResultId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.setResultId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string started_by = 10;
 * @return {string}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getStartedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.setStartedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp last_activity_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getLastActivityAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
*/
proto.vendormanagement.VendorEvaluationCycle.prototype.setLastActivityAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.clearLastActivityAt = function() {
  return this.setLastActivityAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.hasLastActivityAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
*/
proto.vendormanagement.VendorEvaluationCycle.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp ended_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.getEndedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
*/
proto.vendormanagement.VendorEvaluationCycle.prototype.setEndedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vendormanagement.VendorEvaluationCycle} returns this
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.clearEndedAt = function() {
  return this.setEndedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vendormanagement.VendorEvaluationCycle.prototype.hasEndedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vendormanagement.ListVendorEvaluationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendormanagement.ListVendorEvaluationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.ListVendorEvaluationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vendorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
    cycleId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    chatId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendormanagement.ListVendorEvaluationsRequest}
 */
proto.vendormanagement.ListVendorEvaluationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vendormanagement.ListVendorEvaluationsRequest;
  return proto.vendormanagement.ListVendorEvaluationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendormanagement.ListVendorEvaluationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendormanagement.ListVendorEvaluationsRequest}
 */
proto.vendormanagement.ListVendorEvaluationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCycleId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vendormanagement.ListVendorEvaluationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendormanagement.ListVendorEvaluationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.ListVendorEvaluationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVendorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCycleId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string vendor_id = 1;
 * @return {string}
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.getVendorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.ListVendorEvaluationsRequest} returns this
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.setVendorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vendormanagement.ListVendorEvaluationsRequest} returns this
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vendormanagement.ListVendorEvaluationsRequest} returns this
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string cycle_id = 4;
 * @return {string}
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.getCycleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.ListVendorEvaluationsRequest} returns this
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.setCycleId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string chat_id = 5;
 * @return {string}
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.ListVendorEvaluationsRequest} returns this
 */
proto.vendormanagement.ListVendorEvaluationsRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vendormanagement.ListVendorEvaluationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vendormanagement.ListVendorEvaluationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendormanagement.ListVendorEvaluationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.ListVendorEvaluationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    cyclesList: jspb.Message.toObjectList(msg.getCyclesList(),
    proto.vendormanagement.VendorEvaluationCycle.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0),
    canStart: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    cannotStartReason: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendormanagement.ListVendorEvaluationsResponse}
 */
proto.vendormanagement.ListVendorEvaluationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vendormanagement.ListVendorEvaluationsResponse;
  return proto.vendormanagement.ListVendorEvaluationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendormanagement.ListVendorEvaluationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendormanagement.ListVendorEvaluationsResponse}
 */
proto.vendormanagement.ListVendorEvaluationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vendormanagement.VendorEvaluationCycle;
      reader.readMessage(value,proto.vendormanagement.VendorEvaluationCycle.deserializeBinaryFromReader);
      msg.addCycles(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanStart(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCannotStartReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vendormanagement.ListVendorEvaluationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendormanagement.ListVendorEvaluationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.ListVendorEvaluationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCyclesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.vendormanagement.VendorEvaluationCycle.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCanStart();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCannotStartReason();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated VendorEvaluationCycle cycles = 1;
 * @return {!Array<!proto.vendormanagement.VendorEvaluationCycle>}
 */
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.getCyclesList = function() {
  return /** @type{!Array<!proto.vendormanagement.VendorEvaluationCycle>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vendormanagement.VendorEvaluationCycle, 1));
};


/**
 * @param {!Array<!proto.vendormanagement.VendorEvaluationCycle>} value
 * @return {!proto.vendormanagement.ListVendorEvaluationsResponse} returns this
*/
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.setCyclesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vendormanagement.VendorEvaluationCycle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vendormanagement.VendorEvaluationCycle}
 */
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.addCycles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vendormanagement.VendorEvaluationCycle, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vendormanagement.ListVendorEvaluationsResponse} returns this
 */
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.clearCyclesList = function() {
  return this.setCyclesList([]);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vendormanagement.ListVendorEvaluationsResponse} returns this
 */
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool can_start = 3;
 * @return {boolean}
 */
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.getCanStart = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vendormanagement.ListVendorEvaluationsResponse} returns this
 */
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.setCanStart = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string cannot_start_reason = 4;
 * @return {string}
 */
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.getCannotStartReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.ListVendorEvaluationsResponse} returns this
 */
proto.vendormanagement.ListVendorEvaluationsResponse.prototype.setCannotStartReason = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vendormanagement.StartVendorEvaluationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vendormanagement.StartVendorEvaluationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendormanagement.StartVendorEvaluationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.StartVendorEvaluationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vendorId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendormanagement.StartVendorEvaluationRequest}
 */
proto.vendormanagement.StartVendorEvaluationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vendormanagement.StartVendorEvaluationRequest;
  return proto.vendormanagement.StartVendorEvaluationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendormanagement.StartVendorEvaluationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendormanagement.StartVendorEvaluationRequest}
 */
proto.vendormanagement.StartVendorEvaluationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vendormanagement.StartVendorEvaluationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vendormanagement.StartVendorEvaluationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendormanagement.StartVendorEvaluationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.StartVendorEvaluationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVendorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string vendor_id = 1;
 * @return {string}
 */
proto.vendormanagement.StartVendorEvaluationRequest.prototype.getVendorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.StartVendorEvaluationRequest} returns this
 */
proto.vendormanagement.StartVendorEvaluationRequest.prototype.setVendorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vendormanagement.CancelVendorEvaluationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vendormanagement.CancelVendorEvaluationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendormanagement.CancelVendorEvaluationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.CancelVendorEvaluationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cycleId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendormanagement.CancelVendorEvaluationRequest}
 */
proto.vendormanagement.CancelVendorEvaluationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vendormanagement.CancelVendorEvaluationRequest;
  return proto.vendormanagement.CancelVendorEvaluationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendormanagement.CancelVendorEvaluationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendormanagement.CancelVendorEvaluationRequest}
 */
proto.vendormanagement.CancelVendorEvaluationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCycleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vendormanagement.CancelVendorEvaluationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vendormanagement.CancelVendorEvaluationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendormanagement.CancelVendorEvaluationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.CancelVendorEvaluationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCycleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string cycle_id = 1;
 * @return {string}
 */
proto.vendormanagement.CancelVendorEvaluationRequest.prototype.getCycleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.CancelVendorEvaluationRequest} returns this
 */
proto.vendormanagement.CancelVendorEvaluationRequest.prototype.setCycleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vendormanagement.UpdateVendorEvaluationCycleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cycleId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    summary: jspb.Message.getFieldWithDefault(msg, 3, ""),
    overallConfidence: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest}
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vendormanagement.UpdateVendorEvaluationCycleRequest;
  return proto.vendormanagement.UpdateVendorEvaluationCycleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest}
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCycleId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 4:
      var value = /** @type {!proto.vendormanagement.VendorEvaluationConfidence} */ (reader.readEnum());
      msg.setOverallConfidence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vendormanagement.UpdateVendorEvaluationCycleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCycleId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOverallConfidence();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest} returns this
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cycle_id = 2;
 * @return {string}
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.prototype.getCycleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest} returns this
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.prototype.setCycleId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string summary = 3;
 * @return {string}
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest} returns this
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional VendorEvaluationConfidence overall_confidence = 4;
 * @return {!proto.vendormanagement.VendorEvaluationConfidence}
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.prototype.getOverallConfidence = function() {
  return /** @type {!proto.vendormanagement.VendorEvaluationConfidence} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.vendormanagement.VendorEvaluationConfidence} value
 * @return {!proto.vendormanagement.UpdateVendorEvaluationCycleRequest} returns this
 */
proto.vendormanagement.UpdateVendorEvaluationCycleRequest.prototype.setOverallConfidence = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vendormanagement.RefreshVendorEvaluationStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vendormanagement.RefreshVendorEvaluationStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendormanagement.RefreshVendorEvaluationStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.RefreshVendorEvaluationStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    memoryId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendormanagement.RefreshVendorEvaluationStatusRequest}
 */
proto.vendormanagement.RefreshVendorEvaluationStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vendormanagement.RefreshVendorEvaluationStatusRequest;
  return proto.vendormanagement.RefreshVendorEvaluationStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendormanagement.RefreshVendorEvaluationStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendormanagement.RefreshVendorEvaluationStatusRequest}
 */
proto.vendormanagement.RefreshVendorEvaluationStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vendormanagement.RefreshVendorEvaluationStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vendormanagement.RefreshVendorEvaluationStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendormanagement.RefreshVendorEvaluationStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.RefreshVendorEvaluationStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMemoryId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.vendormanagement.RefreshVendorEvaluationStatusRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.RefreshVendorEvaluationStatusRequest} returns this
 */
proto.vendormanagement.RefreshVendorEvaluationStatusRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string memory_id = 2;
 * @return {string}
 */
proto.vendormanagement.RefreshVendorEvaluationStatusRequest.prototype.getMemoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.RefreshVendorEvaluationStatusRequest} returns this
 */
proto.vendormanagement.RefreshVendorEvaluationStatusRequest.prototype.setMemoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cycleId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    summary: jspb.Message.getFieldWithDefault(msg, 3, ""),
    overallConfidence: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest}
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vendormanagement.ConcludeVendorEvaluationCycleRequest;
  return proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest}
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCycleId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 4:
      var value = /** @type {!proto.vendormanagement.VendorEvaluationConfidence} */ (reader.readEnum());
      msg.setOverallConfidence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCycleId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOverallConfidence();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest} returns this
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cycle_id = 2;
 * @return {string}
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.prototype.getCycleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest} returns this
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.prototype.setCycleId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string summary = 3;
 * @return {string}
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest} returns this
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional VendorEvaluationConfidence overall_confidence = 4;
 * @return {!proto.vendormanagement.VendorEvaluationConfidence}
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.prototype.getOverallConfidence = function() {
  return /** @type {!proto.vendormanagement.VendorEvaluationConfidence} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.vendormanagement.VendorEvaluationConfidence} value
 * @return {!proto.vendormanagement.ConcludeVendorEvaluationCycleRequest} returns this
 */
proto.vendormanagement.ConcludeVendorEvaluationCycleRequest.prototype.setOverallConfidence = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.vendormanagement.VendorEvaluationCycleStatus = {
  VENDOR_EVALUATION_CYCLE_STATUS_UNSPECIFIED: 0,
  VENDOR_EVALUATION_CYCLE_STATUS_EVALUATING: 1,
  VENDOR_EVALUATION_CYCLE_STATUS_RUNNING: 2,
  VENDOR_EVALUATION_CYCLE_STATUS_WAITING_ON_APPROVAL: 3,
  VENDOR_EVALUATION_CYCLE_STATUS_WAITING_ON_REQUEST: 4,
  VENDOR_EVALUATION_CYCLE_STATUS_COMPLETED: 5,
  VENDOR_EVALUATION_CYCLE_STATUS_CANCELLED: 6,
  VENDOR_EVALUATION_CYCLE_STATUS_WAITING_ON_VENDOR: 7
};

/**
 * @enum {number}
 */
proto.vendormanagement.VendorEvaluationConfidence = {
  VENDOR_EVALUATION_CONFIDENCE_UNSPECIFIED: 0,
  VENDOR_EVALUATION_CONFIDENCE_HIGH: 1,
  VENDOR_EVALUATION_CONFIDENCE_MEDIUM: 2,
  VENDOR_EVALUATION_CONFIDENCE_LOW: 3
};

goog.object.extend(exports, proto.vendormanagement);
